import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ab122bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "state" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "state" }, null, -1))
const _hoisted_7 = { class: "footer text-right" }

import Avatar from "@/components/Avatar.vue";
import FriendApi from "@/api/FriendApi";
import User from "@/mode/User";
import AccountApi from "@/api/AccountApi";
import { useUserStore } from "@/store/userStore";
import {
  computed,
  getCurrentInstance,
  PropType,
  ref,
} from "vue";
import GroupApi from "@/api/GroupApi";
import Message from "@/mode/Message";
import ChatType from "@/config/ChatType";
import Group from "@/mode/Group";
import MessageType from "@/utils/MessageType";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
interface UserCheck {
  user: User;
  isCheck: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddGroupUser',
  props: {
  group: {
    type: Object as PropType<Group>,
    required: true,
    default: null,
  },
},
  emits: ["reload"],
  setup(__props, { emit }) {

const props = __props;

const { proxy } = getCurrentInstance();


const userStore = useUserStore();
const friends = ref(new Array<UserCheck>());
const user = userStore.getUser();
const userId = user?.id;
if (!userId) {
  AccountApi.toLogin();
}

let tempList = new Array<UserCheck>();
//过滤掉已经存在的用户
if (typeof userId !== "undefined") {
  FriendApi.friends()
    .then((res: any) => {
      res.data.forEach((item: User) => {
        tempList.push({ user: item, isCheck: false });
      });
      return GroupApi.users(props.group.id);
    })
    .then((res: any) => {
      const ids = res.data.map((item: User) => item.id);
      friends.value = tempList.filter(
        (item) => ids.indexOf(item.user.id) === -1
      );
    });
}

const checkedFriends = computed((): Array<UserCheck> => {
  return friends.value.filter((item) => item.isCheck);
});
const userIds = computed((): string[] => {
  return checkedFriends.value.map((item) => item.user.id);
});
const canSave = computed((): boolean => {
  return userIds.value.length === 0;
});



//执行添加到数据库
const addToGroup = () => {
  GroupApi.addUsers(props.group.id, userIds.value).then((res) => {
    if (res) {
      emit("reload");
      if (user) {
        const content = user.name + "邀请了新用户入群";
        let msg: Message = {
          messageType: MessageType.text,
          chatId: props.group.id,
          fromId: user.id,
          mine: true,
          content: content,
          timestamp: new Date().getTime(),
          type: ChatType.GROUP,
        };
        proxy.$ws.sendMessage(msg);
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      class: "d-row",
      gutter: 20
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_scrollbar, { class: "list" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friends.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "user"
                  }, [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(Avatar, {
                        img: item.user.avatar,
                        name: item.user.name
                      }, null, 8, ["img", "name"])
                    ]),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(item.user.name), 1),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: item.isCheck,
                        "onUpdate:modelValue": ($event: any) => ((item.isCheck) = $event),
                        size: "large"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_scrollbar, { class: "list" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkedFriends.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.user.id,
                    class: "user"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(Avatar, {
                        img: item.user.avatar,
                        name: item.user.name
                      }, null, 8, ["img", "name"])
                    ]),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(item.user.name), 1),
                    _hoisted_6
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _withModifiers(addToGroup, ["stop"]),
        disabled: canSave.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定 ")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ], 64))
}
}

})